/**
 * GYMSPIDERR — Card Click Handler
 * Hace que TODA la card de producto/colección sea clickeable,
 * no solo el título.
 *
 * Funciona en PC (click) y móvil (tap).
 * No interfiere con botones interactivos (quick-add, badges, etc.)
 */
(function() {
  'use strict';

  function initCardClicks() {
    var cards = document.querySelectorAll('.card-wrapper');

    cards.forEach(function(card) {
      // Evitar inicializar dos veces
      if (card.dataset.gymClickInit === 'true') return;
      card.dataset.gymClickInit = 'true';

      // Buscar el primer enlace de producto/colección dentro de la card
      var link = card.querySelector('a[href*="/products/"], a[href*="/collections/"]');
      if (!link || !link.href) return;

      var url = link.href;

      // Atributos para mejor accesibilidad
      card.setAttribute('role', 'link');
      card.setAttribute('tabindex', '0');

      // Manejador del click
      card.addEventListener('click', function(e) {
        // Si el clic fue en un elemento interactivo, no hacer nada
        var target = e.target;

        // Lista de elementos que NO deben triggerar navegación
        var interactiveSelectors = [
          'a', 'button', 'input', 'select', 'textarea', 'label',
          '.quick-add', '.quick-add__submit', '.card__badge',
          'modal-opener', 'quick-add-modal', 'product-form',
          'quick-add-bulk', 'quantity-popover', '.quantity__button',
          '.quantity__input', 'volume-pricing'
        ];

        // Verificar si el target o sus padres son interactivos
        for (var i = 0; i < interactiveSelectors.length; i++) {
          if (target.closest(interactiveSelectors[i])) {
            // Si es un <a> que no es el del producto/colección, dejarlo pasar
            if (interactiveSelectors[i] === 'a' && target.closest('a') !== link) {
              return;
            }
            // Si es el link principal, dejarlo manejar el clic nativo
            if (target.closest('a') === link) return;
            // Si es cualquier otro elemento interactivo, no navegar
            if (interactiveSelectors[i] !== 'a') return;
          }
        }

        // Navegar al producto/colección
        e.preventDefault();
        window.location.href = url;
      });

      // Soporte para teclado (Enter o Space)
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          var target = e.target;
          // Solo navegar si el foco está en la card, no en un botón dentro
          if (target === card) {
            e.preventDefault();
            window.location.href = url;
          }
        }
      });
    });
  }

  // Inicializar al cargar la página
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardClicks);
  } else {
    initCardClicks();
  }

  // Reinicializar cuando Shopify carga contenido dinámicamente
  // (por ejemplo, al filtrar colecciones o cambiar de página en pagination)
  document.addEventListener('shopify:section:load', initCardClicks);

  // Observador para detectar nuevas cards añadidas al DOM
  // (útil para paginación AJAX, infinite scroll, etc.)
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      var shouldReinit = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList && node.classList.contains('card-wrapper') ||
              node.querySelector && node.querySelector('.card-wrapper'))) {
            shouldReinit = true;
          }
        });
      });
      if (shouldReinit) initCardClicks();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
